import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { api } from "@/lib/api";
import { ScreenHeader, Spinner } from "@/components/kit";
import { Page } from "@/components/layout";

export function Learn() {
  const navigate = useNavigate();
  const [items, setItems] = useState(null);
  useEffect(() => {
    api("/articles").then(setItems).catch(() => setItems([]));
  }, []);
  return (
    <div data-testid="learn-screen">
      <ScreenHeader testId="learn-back" label="Learn" />
      <Page className="flex flex-col gap-3 pb-12">
        <h1 className="t-h1">LEARN.</h1>
        {!items ? <Spinner className="mx-auto mt-8" /> : !items.length ? <p className="t-body">No articles yet.</p> : (
          <div className="grid gap-3 md:grid-cols-2">
            {items.map((item, index) => (
              <button key={item.id} type="button" data-testid={`learn-item-${index}`} onClick={() => navigate(`/learn/${item.id}`)} className="focus-ring flex items-center gap-3 rounded-[20px] border border-line bg-white p-3 text-left transition-all hover:border-ocean">
                {item.cover_url ? <img src={item.cover_url} alt="" className="h-[72px] w-[72px] rounded-xl object-cover" /> : null}
                <span className="flex min-w-0 flex-1 flex-col gap-1">
                  <span className="t-title">{item.title}</span>
                  <span className="t-caption line-clamp-2">{item.body}</span>
                </span>
              </button>
            ))}
          </div>
        )}
      </Page>
    </div>
  );
}

export function Article() {
  const { id } = useParams();
  const [a, setA] = useState(null);
  const [err, setErr] = useState(null);
  useEffect(() => {
    api(`/articles/${id}`).then(setA).catch((e) => setErr(e.message));
  }, [id]);
  return (
    <div data-testid="article-screen">
      <ScreenHeader testId="article-back" label="Hair school" fallback="/learn" />
      <Page className="flex flex-col gap-4 pb-12">
        {err ? <p className="t-body">{err}</p> : !a ? <Spinner className="mx-auto mt-8" /> : (
          <>
            {a.cover_url ? <img src={a.cover_url} alt="" className="aspect-video w-full rounded-[20px] object-cover" /> : null}
            <h1 data-testid="article-title" className="t-h1">{a.title}</h1>
            <p data-testid="article-body" className="t-body whitespace-pre-line !leading-6">{a.body}</p>
          </>
        )}
      </Page>
    </div>
  );
}
